import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Instagram, ArrowRight } from "lucide-react";
import Logo from "@/components/Logo";
import { cn } from "@/lib/utils";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground text-white mt-auto">
      {/* Main footer content */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2 w-fit">
              <Logo className="h-8 w-auto" />
              <div className="flex flex-col">
                <span className="text-xl font-bold">Tekton</span>
                <span className="text-xs text-white/60">Toneladas de tecnología</span>
              </div>
            </Link>
            <p className="text-white/70 text-sm leading-relaxed">
              Tu tienda de tecnología de confianza en Costa Rica. Cámaras de seguridad, equipos de cómputo y más.
            </p>
            {/* Social icons */}
            <div className="flex items-center gap-3">
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className={cn(
                  "w-9 h-9 rounded-full flex items-center justify-center",
                  "bg-white/10 text-white",
                  "hover:bg-primary hover:text-white",
                  "transition-all duration-300"
                )}
                aria-label="Facebook"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className={cn(
                  "w-9 h-9 rounded-full flex items-center justify-center",
                  "bg-white/10 text-white",
                  "hover:bg-primary hover:text-white",
                  "transition-all duration-300"
                )}
                aria-label="Instagram"
              >
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-bold text-base mb-4">Navegación</h3>
            <ul className="space-y-2">
              {[
                { name: "Inicio", href: "/" },
                { name: "Catálogo", href: "/catalogo" },
                { name: "Nosotros", href: "/nosotros" },
                { name: "Contacto", href: "/contacto" },
              ].map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-white/70 hover:text-white text-sm transition-colors flex items-center gap-1 group"
                  >
                    <ArrowRight className="h-3 w-3 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="font-bold text-base mb-4">Categorías</h3>
            <ul className="space-y-2">
              {[
                "Cámaras de Seguridad",
                "Equipos de Cómputo",
                "Accesorios",
                "Redes y Conectividad",
              ].map((category) => (
                <li key={category}>
                  <Link
                    to="/catalogo"
                    className="text-white/70 hover:text-white text-sm transition-colors flex items-center gap-1 group"
                  >
                    <ArrowRight className="h-3 w-3 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                    {category}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-base mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 text-accent mt-0.5 flex-shrink-0" />
                <span className="text-white/70 text-sm">info@tekton.cr</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 text-accent mt-0.5 flex-shrink-0" />
                <span className="text-white/70 text-sm">+506 0000 0000</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-accent mt-0.5 flex-shrink-0" />
                <span className="text-white/70 text-sm">San José, Costa Rica</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 py-4">
          <p className="text-center text-sm text-white/50">
            © {currentYear} Tekton. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
